module.exports = __webpack_public_path__ + "img/world-energy-trends-cover-2023.7b36bca.jpg";